import { useState, useEffect } from "react";
import { TableLoader } from "../../../components/LoaderC";
import styles from "./leases.module.css";
import LeaseCard from "./component/LeaseCard";
import LeaseFilter from "../components/Filter";
import { TablePagination } from "@mui/material";

const LeaseGridView = ({ handleView, filterData, setFilterData, isGridView, contentLoading, allData }) => {
    const [filterredData, setFilterredData] = useState([]);
    const [perPage, setPerPage] = useState(8);
    const [page, setPage] = useState(0);

    useEffect(() => {
        let filterredDataTemp = allData?.filter(i => i?.tenant_id);

        if (filterData?.searchKey !== "") {
            let inputVal = filterData?.searchKey;
            inputVal = inputVal.toLowerCase();
            filterredDataTemp = filterredDataTemp.filter((item) => item.tenant_name.toLowerCase().includes(inputVal) || item.property_name.toLowerCase().includes(inputVal) || item.apt_no.toLowerCase().includes(inputVal) || item.formatted_amount.toLowerCase().includes(inputVal) || item.formatted_rent.toLowerCase().includes(inputVal));
        }

        if (filterData?.property !== "" && filterData?.property !== "all") {
            filterredDataTemp = filterredDataTemp.filter((i) => i.property_id === filterData.property);
        }

        if (filterData?.apartment !== "" && filterData?.apartment !== "all") {
            filterredDataTemp = filterredDataTemp.filter((i) => i.apt_id === filterData.apartment);
        }

        if (filterData?.status !== "" && filterData?.status !== "all") {
            filterredDataTemp = filterredDataTemp.filter((i) => i?.lease_status.indexOf(parseInt(filterData.status)) > -1);
        }

        setFilterredData(filterredDataTemp);
    }, [allData, filterData]);

    return (<div className={`${styles.BodyCon}`}>
        <div className={`${styles.mainCardDiv}`}>
            <div className={`${styles.mainCard}`}>
                <div className="control-pane">

                    {contentLoading && (<div className="Loader TableLoader"><TableLoader /></div>)}

                    {!contentLoading && (<>
                        <LeaseFilter isGridView={isGridView} handleView={handleView.bind(this)} filterData={filterData} setFilterData={setFilterData.bind(this)} setPage={setPage.bind(0)} />

                        <div className={`${styles.NotesRow}`}>

                            {filterredData.map((item, index) => {
                                return (perPage === -1 || (index >= page * perPage && index < page * perPage + perPage)) ? (<LeaseCard item={item} />) : null;
                            })}

                            {filterredData.length > 0 && (<div className="Pagination TablePaginationNew List">
                                <TablePagination
                                    count={filterredData.length}
                                    color="primary"
                                    page={page}
                                    rowsPerPage={perPage}
                                    onPageChange={(e, v) => setPage(v)}
                                    rowsPerPageOptions={[
                                        { label: '4', value: 4 },
                                        { label: '8', value: 8 },
                                        { label: '16', value: 16 },
                                        { label: 'All', value: -1 },
                                    ]}
                                    onRowsPerPageChange={(e) => {
                                        setPage(0);
                                        setPerPage(e.target.value);
                                    }}
                                    labelRowsPerPage={'Leases per Page:'}
                                />
                            </div>)}

                            {filterredData.length === 0 && (<div className={`${styles.NoDataMain}`}>
                                <div className={`${styles.NoDataIMG}`}>
                                    <img src="/static/img/no-lease.png" alt="No Data" />
                                </div>
                                <p className={`${styles.NoDataText}`}>Unfortunately!</p>
                                <p className={`${styles.NoDataTextSub}`}>we couldn't find any leases at this time.</p>
                            </div>)}

                        </div>

                    </>)}

                </div>
            </div>
        </div>
    </div >)
}

export default LeaseGridView;